import { render } from "./PagoPersonal.vue?vue&type=template&id=53d291d6"
import script from "./PagoPersonal.vue?vue&type=script&lang=js"
export * from "./PagoPersonal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__